// List of country codes and country names for phone input
const codes = [
  { code: '+1', name: 'United States/Canada' },
  { code: '+44', name: 'United Kingdom' },
  { code: '+49', name: 'Germany' },
  { code: '+33', name: 'France' },
  { code: '+7', name: 'Russia' },
  { code: '+380', name: 'Ukraine' },
  { code: '+91', name: 'India' },
  { code: '+61', name: 'Australia' },
  { code: '+81', name: 'Japan' },
  { code: '+86', name: 'China' },
  { code: '+34', name: 'Spain' },
  { code: '+39', name: 'Italy' },
  { code: '+48', name: 'Poland' },
  { code: '+351', name: 'Portugal' },
  { code: '+40', name: 'Romania' },
  { code: '+420', name: 'Czech Republic' },
  { code: '+421', name: 'Slovakia' },
  { code: '+36', name: 'Hungary' },
  { code: '+372', name: 'Estonia' },
  { code: '+371', name: 'Latvia' },
  { code: '+370', name: 'Lithuania' },
  { code: '+47', name: 'Norway' },
  { code: '+46', name: 'Sweden' },
  { code: '+45', name: 'Denmark' },
  { code: '+358', name: 'Finland' },
  { code: '+43', name: 'Austria' },
  { code: '+31', name: 'Netherlands' },
  { code: '+32', name: 'Belgium' },
  { code: '+41', name: 'Switzerland' },
  { code: '+90', name: 'Turkey' },
  { code: '+966', name: 'Saudi Arabia' },
  { code: '+971', name: 'United Arab Emirates' },
  { code: '+972', name: 'Israel' },
  { code: '+82', name: 'South Korea' },
  { code: '+62', name: 'Indonesia' },
  { code: '+63', name: 'Philippines' },
  { code: '+60', name: 'Malaysia' },
  { code: '+65', name: 'Singapore' },
  { code: '+64', name: 'New Zealand' },
  { code: '+27', name: 'South Africa' },
  { code: '+254', name: 'Kenya' },
  { code: '+234', name: 'Nigeria' },
  { code: '+212', name: 'Morocco' },
  { code: '+20', name: 'Egypt' },
  { code: '+213', name: 'Algeria' },
  { code: '+216', name: 'Tunisia' },
  { code: '+30', name: 'Greece' },
  { code: '+353', name: 'Ireland' },
  { code: '+52', name: 'Mexico' },
  { code: '+55', name: 'Brazil' },
  { code: '+54', name: 'Argentina' },
  { code: '+56', name: 'Chile' },
  { code: '+57', name: 'Colombia' },
  { code: '+51', name: 'Peru' },
  { code: '+58', name: 'Venezuela' },
  // ... add more as needed ...
];

export const countryCodes = codes.sort((a, b) => {
  return a.name.localeCompare(b.name);
}); 